<div>
    <div class="edit-button-style section-title" (click)="editLngUsageEvent()">
        <img alt="edit" src="/assets/img/edit-icon.svg"> Edit
    </div>
    <snl-side-panel panelType="close" [headerName]="headerName" size="large" [(isOpen)]="openEditLngUsage">
        <div sidePanelContent class="largeSidepanelWidth">
            <ng-container *ngIf="editLngUsageVal === 'editLngUsageVal_1'">
                <div class="editLngUsageVal_1">
                    <div class="d-flex justify-content-between">
                        <p class="color__primary body-b1">Is LNG in use</p>
                        <snl-switch [toggleState]="toggleLngVal" (toggle)="toggleLngUsage($event)"
                            [activeText]="'Yes'" [inActiveText]="'No'"></snl-switch>
                    </div>
                    <ng-container *ngIf="getLngData?.hasPreviousChange === true">
                        <div class="datepickerLngUsage datepickerLngUsageNoChange mt-24" *ngIf="noChangeLngEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                                (selectedDate)="lngUsageDate($event)" 
                                title="Effective date of change"
                                [min]="minSelectableDate"
                                [startMonthDate]="effectiveDate"
                                [setDefaultDate]="false"
                                class="lngEffectiveDate">
                            </snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input reasonForchangeLng editPoolPointsVal_1ReasonInput mt-24">
                            <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                                [value]="lngUsageReason"
                                [isError]="isTextError" (fieldValue)="lngUsagefieldValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="editLngUsageVal === 'editLngUsageVal_2'">
                <div class="editLngUsageVal_2">
                    <div class="d-flex justify-content-between">
                        <p class="color__primary body-b1">Is LNG in use</p>
                        <snl-switch [toggleState]="toggleLngVal" (toggle)="toggleLngUsage($event)"
                            [activeText]="'Yes'" [inActiveText]="'No'"></snl-switch>
                    </div>
                    <div class="datepickerLngUsage mt-24">
                        <snl-date-picker-dropdown datePickerType="date"
                            (selectedDate)="lngUsageDate($event)" 
                            title="Effective date of change"
                            [min]="minSelectableDate"
                            class="lngEffectiveDate">
                        </snl-date-picker-dropdown>                      
                    </div>
                    <div class="multi-input reasonForchangeLng editPoolPointsVal_1ReasonInput mt-24">
                        <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                            [isError]="isTextError" (fieldValue)="lngUsagefieldValue($event)">
                        </snl-multi-line-input>                
                    </div>   
                    <ng-container *ngIf="getLngData?.hasPreviousChange === true">
                        <div class="currentPool mt-24" *ngIf="getLngData?.currentEffectiveDate !== null">
                            <p class="body-b color__secondary">Current effective date of change</p>
                            <p class="section-title color__primary">
                                {{getLngData?.currentEffectiveDate | date:'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="currentPool mt-24" *ngIf="getLngData?.currentReason !== null">
                            <p class="body-b color__secondary">Current reason for change</p>
                            <p class="section-title color__primary">
                                {{getLngData?.currentReason}}
                            </p>
                        </div>
                    </ng-container>           
                </div>
            </ng-container>
            <ng-container *ngIf="editLngUsageVal === 'editLngUsageVal_3'">
                <div class="editLngUsageVal_3">
                    <div class="LngNotificationWrap" *ngIf="showLngDiscardBanner">
                        <div class="d-flex col-gap-8">     
                            <figure>
                                <img src="assets/img/infoBlue.svg" alt="information">
                            </figure>              
                            <span class="body-b1 color__primary">To change the current details, you need
                                to discard the upcoming change first.</span>
                        </div>
                    </div>
                    <div class="mt-24">
                        <p class="color__secondary body-b">Current - Is LNG in use?</p>
                        <p class="color__primary section-title">{{getLngData?.currentLng === 1 ? 'Yes' : 'No'}}</p>
                    </div>
                    <ng-container *ngIf="getLngData?.hasPreviousChange">
                        <div class="mt-24" *ngIf="getLngData?.currentEffectiveDate !== null">
                            <p class="body-b color__secondary">Effective date of change</p>
                            <p class="section-title color__primary">
                            {{getLngData?.currentEffectiveDate | date:'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="mt-24" *ngIf="getLngData?.currentReason !== null">
                            <p class="body-b color__secondary">Reason for change</p>
                            <p class="section-title color__primary">
                                {{getLngData?.currentReason}}
                            </p>
                        </div>
                    </ng-container>
                    <div class="single-line"></div>
                    <div class="d-flex mt-24 justify-content-between">
                        <div>
                            <p class="body-b color__secondary">Upcoming - Is LNG in use?</p>
                            <p class="color__primary section-title">{{getLngData?.upComingLng === 1 ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="d-flex col-gap-8 discardWrapLng" (click)="discardLngEvent()">
                            <figure >
                                <img src="assets/img/delBlue.svg" alt="information">
                            </figure>
                            <span class="discardTextLng section-title">Discard</span>
                        </div>
                    </div>
                    <ng-container>
                        <div class="datepickerLngUsage datepickerUpcomingLngUsage mt-24" *ngIf="upcomingLngEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                                (selectedDate)="upcomingLngUsageDate($event)" 
                                title="Effective date of change"
                                [min]="minSelectableDate"
                                [startMonthDate]="effectiveDate"
                                [setDefaultDate]="false"
                                class="lngEffectiveDate"></snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input reasonForchangeLng editPoolPointsVal_1ReasonInput mt-24">
                            <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                                [value]="upcomingLngReasonValue"
                                [isError]="isTextError" (fieldValue)="upcomingLngUsageValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="editLngUsageVal === 'editLngUsageVal_4' && openEditLngUsage === true">
                <div class="editLngUsageVal_4">
                    <div class="LngNotificationWrap">
                        <div class="d-flex col-gap-8">                        
                            <figure>
                                <img src="assets/img/infoBlue.svg" alt="information">
                            </figure>                   
                            <span class="body-b1 color__primary">You can modify the details until <span
                                class="section-title color__primary fw-700">{{getLngData?.nextCalculationDate | date: 'dd MMM yyyy'}}</span> without affecting
                                distrubtion.
                            </span>    
                        </div>
                    </div>
                    <div class="mt-24">
                        <p class="color__secondary body-b">Current - Is LNG in use?</p>
                        <p class="color__primary section-title">{{getLngData?.currentLng === 1 ? 'Yes' : 'No'}}</p>
                    </div>
                    <div class="datepickerLngUsage mt-24" *ngIf="pendingLngEffectiveDate as effectiveDate">
                        <snl-date-picker-dropdown datePickerType="date"
                            (selectedDate)="pendingLngUsageDate($event)" 
                            title="Effective date of change"
                            [min]="minSelectableDate"
                            [startMonthDate]="effectiveDate"
                            [setDefaultDate]="false"
                            class="lngEffectiveDate">
                        </snl-date-picker-dropdown>      
                    </div>
                    <div class="multi-input reasonForchangeLng editPoolPointsVal_1ReasonInput mt-24">
                        <snl-multi-line-input 
                            [label]="'Reason for change'" 
                            [maxLength]="maxLength"
                            [value]="pendingLngUsageReason"
                            [isError]="isTextError"
                            (fieldValue)="pendingLngUsageValue($event)">
                        </snl-multi-line-input>
                    </div>       
                    <div class="single-line"></div>            
                    <div class="d-flex mt-24 justify-content-between">
                        <div>
                            <p class="body-b color__secondary">Previous - Is LNG in use?</p>
                            <p class="color__primary section-title">{{getLngData?.previousLng === 1 ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="d-flex col-gap-8 discardWrapLng" (click)="revertLngEvent()">
                            <figure >
                                <img src="assets/img/arrowLeftIcon.svg" alt="arrowLeftIcon">
                            </figure>
                            <span class="discardTextLng section-title" >Restore previous
                            </span>
                        </div>
                    </div>
                    <ng-container *ngIf="getLngData?.hasPreviousChange">
                        <div class="currentPool mt-24" *ngIf="getLngData?.previousEffectiveDate">
                            <p class="body-b color__secondary">Effective date of change</p>
                            <p class="section-title color__primary">
                               {{getLngData?.previousEffectiveDate | date: 'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="currentPool mt-24" *ngIf="getLngData?.previousReason">
                            <p class="body-b color__secondary">Reason for change</p>
                            <p class="section-title color__primary">
                                {{getLngData?.previousReason}}
                            </p>
                        </div>
                    </ng-container>           
                </div>
            </ng-container>
        </div>
        <div sidePanelFooterContent>
            <ng-container *ngIf="getLngData?.hasPreviousChange">
                <snl-button   *ngIf="getLngData?.status === 'upcomingChange' " type="primary" size="large" (click)="openEditLngUsage = false;updateLngUsage()" 
                    [disabled]="!upcomingLngEffectiveDate ||
                    !upcomingLngReasonValue || 
                    upcomingLngUsageReasonError"><!--  || !discardLngSuccess -->
                    Save and update
                </snl-button>  
                <snl-button   *ngIf="getLngData?.status === 'pendingCalculation' " type="primary" size="large" (click)="openEditLngUsage = false;updateLngUsage()" 
                    [disabled]="!pendingLngEffectiveDate ||
                    !pendingLngUsageReason || 
                    pendingLngUsageReasonError">
                    Save and update
                </snl-button>  
                <snl-button   *ngIf="getLngData?.status === 'noChange' " type="primary" size="large" (click)="openEditLngUsage = false;updateLngUsage()" 
                    [disabled]="!noChangeLngEffectiveDate || !lngUsageReason || lngUsageReasonError">
                    Save and update
                </snl-button> 
            </ng-container>
            <ng-container *ngIf="!getLngData?.hasPreviousChange">
                <snl-button class="pending"  type="primary" size="large" 
                    [disabled]="!selectedLngUsageDate || lngUsageReason === '' || lngUsageReasonError"
                    (click)="openEditLngUsage = false;updateLngUsage()">
                    Save and update
                </snl-button>  
            </ng-container>
            <snl-button type="secondary" size="large"
                (click)="openEditLngUsage = false;closeLngSidePanel()">Cancel
            </snl-button>            
        </div>
    </snl-side-panel>
</div>

<!-- -----discard lng---- -->
 <snl-modal (click)="openDiscardLngUsage = false" [type]="'small'" [open]="openDiscardLngUsage">
  <div slot="heading" class="ppLargeModalHeading"> Discard upcoming change </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="body-b1 color__primary">
            You are about to cancel the scheduled LNG usage change, effective from 
            <span class="section-title">
                {{getLngData?.upcomingEffectiveDate | date:'dd MMM yyyy'}}.
            </span>
            <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openDiscardLngUsage = false;discardLngUsage()">Discard</snl-button>
      <snl-button type="secondary" size="large" (click)="openDiscardLngUsage = false;cancelDiscardLngUsage()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>

<!-- -----restore lng---- -->
 <snl-modal (click)="openRestoreLngUsage = false" [type]="'small'" [open]="openRestoreLngUsage">
  <div slot="heading" class="ppLargeModalHeading"> Restore previous lng</div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="color__primary body-b1">
           You are about to change the current lng back to the previous configuration. 
           <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openRestoreLngUsage = false;revertLngChanges();">Restore</snl-button>
      <snl-button type="secondary" size="large" (click)="openRestoreLngUsage = false;cancelLngRestore()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>